import * as React from "react";
import { forwardRef } from "react";
const SvgTelephonePickup = (props, ref) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 100 100"
    ref={ref}
    {...props}
  >
    <path d="M36.714 64.203c-8.378-8.28-15.58-17.758-21.597-28.431l.378-1.22a14.3 14.3 0 0 1-1.44-7.42 14.28 14.28 0 0 1 13.44-13.114c4.253 8.175 8.668 15.312 13.266 21.169a14.28 14.28 0 0 1-8.534 6.77c7.443 9.753 15.397 18.464 25.58 26.801a14.28 14.28 0 0 1 7.024-9.515c7.392 5.503 14.465 10 21.156 13.266a14.28 14.28 0 0 1-9.03 12.503 14.28 14.28 0 0 1-10.182.063l-1.372.365c-10.746-5.884-20.309-12.96-28.69-21.24Z" />
  </svg>
);
const ForwardRef = forwardRef(SvgTelephonePickup);
export default ForwardRef;
